import React, { createContext, useContext, useEffect, useState } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { merge } from 'lodash';
import { LogLevel } from '@azure/msal-browser';

const DEFAULT_CONFIG = {
  "gtmId": "GTM-P5JSM4P",
  "gtmEnabled": false,
  "BASE_URL": "https://gen-api-dev-1.main.oecd.org:8150",
  "API_BASE_URL": "https://gen-api-dev-1.main.oecd.org:8150/api",
  "adfsScopes": ["api://legalinstruments-dev.oecd.org/openid"],
  "msalConfig": {
    "auth": {
      "clientId": "ui://legalinstruments-dev.oecd.org",
      "authority": "https://adfs-dev.oecd.org/adfs",
      "redirectUri": "http://localhost:3000",
      "postLogoutRedirectUri": "/",
      "navigateToLoginRequestUrl": false,
      "knownAuthorities": [
        "adfs-dev.oecd.org"
      ]
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          return; // disable logging
          if (containsPii) {
            return;
          }
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;
            case LogLevel.Info:
              console.info(message);
              return;
            case LogLevel.Verbose:
              console.debug(message);
              return;
            case LogLevel.Warning:
              console.warn(message);
              return;
            default:
              return;
          }
        },
      },
    },
  }
};

export const DEFAULT_CONFIG_NAME = {
  BASE_URL: "BASE_URL",
}

const ConfigContext = createContext({});

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    fetch(`/app-config.json?v=${new Date().getTime()}`)
      .then(rsp => rsp.ok ? rsp.json() : {})
      .then(appConfig => {
        const nextConfig = merge({}, DEFAULT_CONFIG, appConfig);
        window.LiCompUiConfig = nextConfig
        setConfig(nextConfig);
      })
      .catch(err => {
        console.error(err);
        window.LiCompUiConfig = DEFAULT_CONFIG
        setConfig(DEFAULT_CONFIG);
      })
  }, []);

  if (!config) {
    return (
      <div>
        <LinearProgress variant={'query'} />
      </div>
    );
  }

  const getConfigValue = (name) => {
    return config[name];
  }

  const value = { ...config, getConfigValue };

  return (
    <ConfigContext.Provider value={value}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => useContext(ConfigContext);
